<template>
  <div class="login">
    <fragment v-if="mode === 'register'">
      <div class="loginWapper">
        <v-card class="tab-Program">
          <div class="title-login">
            <div class="up-title">
              <h5>سلام دوست عزیزم</h5>
              <div class="img-title-login">
                <img src="../../assets/image/welcome_emoji.jpg" alt="" />
              </div>
            </div>
            <span>
              به دو روش میتونی ثبت نام و وارد جمع خوشبخت ها و موفق ها بشی
            </span>
          </div>
          <v-tabs v-model="tab" background-color="#fff" color="#f5d240" grow>
            <v-tab v-for="item in items" :key="item.index">
              <span>{{ item.title }}</span>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item
              class="item-content"
              v-for="(item, index) in items"
              :key="index"
            >
              <v-card color="#fff" flat class="content-tab">
                <div v-if="item.category === 'mobile'">
                  <div class="loginInput">
                    <v-col cols="12">
                      <v-text-field
                        v-model="fullname"
                        class="inputPrice"
                        label="نام و نام خانوادگی"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        label="شماره موبایل"
                        v-model="mobile"
                        class="inputPrice"
                        type="number"
                        maxlength="11"
                      ></v-text-field>
                    </v-col>
                  </div>
                  <div class="buttonBox">
                    <v-btn
                      block
                      depressed
                      color="#0000CD"
                      class="singin"
                      @click="submitRegister()"
                      >ثبت نام
                    </v-btn>
                    <v-btn block outlined color="#0000CD" @click="login">
                      حساب کاربری دارم وارد حسابم میشوم
                    </v-btn>
                  </div>
                </div>

                <div v-else-if="item.category === 'email'">
                  <div class="loginInput">
                    <v-col cols="12">
                      <v-text-field
                        v-model="fullname"
                        class="inputPrice"
                        label="نام و نام خانوادگی"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        label=" ایمیل"
                        v-model="user_profile_email"
                        class="inputPrice"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </div>
                  <div class="buttonBox">
                    <v-btn
                      block
                      depressed
                      color="#0000CD"
                      class="singin"
                      @click="submitRegister()"
                      >ثبت نام
                    </v-btn>
                    <v-btn block outlined color="#0000CD" @click="login">
                      حساب کاربری دارم وارد حسابم میشوم
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
    </fragment>
    <fragment v-else-if="mode === 'confirm'">
      <div class="loginWapper2">
        <v-card width="100%" height="100%">
          <div class="loginDetail">
            <div class="titleLogin">
              <h5>
                تا لحظاتی دیگر پیامکی حاوی کد تایید به شماره همراه شما ارسال
                خواهد شد, با وارد کردن کد تایید وارد حساب کاربری خود شوید
              </h5>
            </div>
            <div class="loginInput">
              <v-text-field
                v-model="codeConfirm"
                class="pincondeInput inputPrice percentageinput"
                placeholder="----"
                maxlength="4"
                type="number"
              ></v-text-field>
            </div>
            <div class="buttonBox">
              <v-btn
                block
                depressed
                color="#0000CD"
                class="singin"
                @click="submitLoginCode()"
                >نهایی سازی
              </v-btn>
              <v-btn block outlined color="#0000CD" @click="register"
                >{{ Start_Time }} ثانیه تا ارسال مجدد
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>
    </fragment>
    <fragment v-else-if="mode === 'login'">
      <div class="loginWapper">
        <v-card class="tab-Program">
          <div class="title-login">
            <span>
              برای ورود به حساب کاربری,شماره همراه و یا ایمیلی که قبلا ثبت کرده
              اید وارد کنید
            </span>
          </div>
          <v-tabs v-model="tab" background-color="#fff" color="#f5d240" grow>
            <v-tab v-for="item in items" :key="item.index">
              <span>{{ item.titles }}</span>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item
              class="item-content"
              v-for="item in items"
              :key="item.index"
            >
              <v-card color="#fff" flat class="content-tab">
                <div v-if="item.category === 'mobile'">
                  <div class="loginInput">
                    <v-col cols="12">
                      <v-text-field
                        label="شماره موبایل"
                        v-model="mobile"
                        class="inputPrice"
                        type="number"
                        maxlength="11"
                      ></v-text-field>
                    </v-col>
                  </div>
                  <div class="buttonBox">
                    <v-btn
                      block
                      depressed
                      color="#0000CD"
                      class="singin"
                      @click="submitLogin()"
                      >ورود به حساب کابری
                    </v-btn>
                    <v-btn block outlined color="#0000CD" @click="register"
                      >حساب کاربری ندارم,ثبت نام میکنم
                    </v-btn>
                  </div>
                </div>

                <div v-else-if="item.category === 'email'">
                  <div class="loginInput">
                    <v-col cols="12">
                      <v-text-field
                        label=" ایمیل"
                        v-model="user_profile_email"
                        class="inputPrice"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </div>
                  <div class="buttonBox">
                    <v-btn
                      block
                      depressed
                      color="#0000CD"
                      class="singin"
                      @click="submitLogin()"
                      >ورود به حساب کابری
                    </v-btn>
                    <v-btn block outlined color="#0000CD" @click="register">
                      حساب کاربری ندارم,ثبت نام میکنم
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
    </fragment>
  </div>
</template>
<script>
import oracle from "@/oracle";

export default {
  name: "register",
  data: () => ({
    Start_Time: "",
    codeConfirm: "",
    mode: "register",
    tab: 0,
    fullname: "",
    mobile: "",
    user_profile_email: "",
    items: [
      {
        id: 0,
        category: "mobile",
        title: "ثبت نام با موبایل ",
        titles: "ورود با موبایل",
      },
      {
        id: 1,
        category: "email",
        title: " ثبت نام با ایمیل",
        titles: "ورود با ایمیل",
      },
    ],
  }),
  watch: {
    tab: function() {
      if (this.tab == 0) {
        this.user_profile_email = "";
      } else this.tab == 1;
      {
        this.fullname = "";
        this.mobile = "";
      }
    },
  },

  methods: {
    submitLoginCode() {
      let data = {
        captcha: this.codeConfirm,
        phone: this.mobile,
        email: this.user_profile_email,
      };
      oracle.axios("user/verify", data, this.Final);
    },
    Final() {
      this.$router.push("home");
    },
    register() {
      this.mode = "register";
    },
    login() {
      this.mode = "login";
    },
    confirm(response) {
      if (
        response.data &&
        response.data.captcha &&
        response.data.captcha != null
      ) {
        this.codeConfirm = response.data.captcha;
      }
      this.mode = "confirm";
    },
    submitLogin() {
      if (this.mobile == "") {
        this.mobile = null;
      }
      if (this.user_profile_email == "") {
        this.user_profile_email = null;
      }
      let data = {
        phone: this.mobile,
        email: this.user_profile_email,
      };

      oracle.axios("user/login", data, this.confirm);
    },
    submitRegister() {
      if (this.mobile == "") {
        this.mobile = null;
      }
      if (this.user_profile_email == "") {
        this.user_profile_email = null;
      }
      let data = {
        username: this.fullname,
        phone: this.mobile,
        email: this.user_profile_email,
      };

      oracle.axios("user/register", data, this.confirm);
    },
  },
};
</script>
<style>
.tab-Program {
  height: 100vh;
}

.tab-Program span {
  padding: 10px;
  font-size: 13px;
}

.tab-Program .v-tab--active span {
  color: #f5d240 !important;
}

.item-content {
  height: 70vh;
  overflow: auto;
}
.tab-Program span {
  letter-spacing: initial;
}
.login {
  background-image: url("../../assets/image/background.jpg");
  height: 100%;
  position: relative;
  background-size: cover;
  padding: 0;
  z-index: 10;
  overflow: auto;
  letter-spacing: inherit;
}
.login button {
  letter-spacing: inherit;
}
.loginWapper {
  margin: 0 auto;
  width: 100%;
  height: 100%;
  margin-top: 129px;
}

.loginWapper2 {
  margin: 0 auto;
  width: 100%;
  height: 70%;
  margin-top: 252px;
}

.titleLogin {
  margin-bottom: 2em;
  border-bottom: 1px solid #707070;
  padding: 15px;
}

.pincondeInput input {
  text-align: center;
  letter-spacing: 5px;
}

.titleLogin h5 {
  text-align: center;
  color: #707070;
  font-size: 13px;
  font-weight: 100;
}

.loginInput div {
  color: #f5d240 !important;
  caret-color: #f5d240 !important;
}

.loginInput label {
  font-size: 13px;
}

.loginInput .v-input .v-application .primary--text {
  color: #f5d240 !important;
  caret-color: #f5d240 !important;
}

.loginInput {
  padding: 15px 20px;
}

.inputPrice input[type="number"] {
  -moz-appearance: textfield;
}

.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.percentageinput {
}

.buttonBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80%;
  margin: 0 auto;
}

.buttonBox button {
  margin-bottom: 1em;
}

.singin {
  color: #fff !important;
}

.loginWapper .v-item-group {
  padding: 0;
}

.img-title-login {
  width: 25px;
  height: 25px;
  border-radius: 50px;
  overflow: hidden;
}

.img-title-login img {
  width: 100%;
  height: 100%;
}

.up-title {
  display: flex;
  justify-content: center;
  padding: 15px;
}

.up-title h5 {
  font-size: 15px;
}

.title-login span {
  font-size: 12px;
  color: #707070;
  padding: 15px;
}

.title-login {
  display: flex;
  flex-direction: column;
  text-align: center;
}
</style>
